import { gql } from '../../../../../hooks'

export const DELETE_BRANDS = gql`
  mutation AdministrationDeleteComponentBrands($id: ID!) {
    aDelete(path: "component/brands", id: $id) {
    }
  }
`

export const LIST_BRANDS = gql`
  query AdministrationListComponentBrands(
    $page: Int
    $limit: Int
    $filter: JSONObject
  ) {
    aList(
      path: "component/brands"
      filter: $filter
      page: $page
      limit: $limit
    ) {
      pagination {
        page
        limit
        number_of_pages
      }
    }
  }
`
